import { withNamespaces } from 'react-i18next';
import {
    Button,
    Card,
    CardBody,
    Col,
    Row,
} from 'reactstrap';

const RecentDocuments = ({
    documents = [],
    t,
}) => {
    return (
        <Card>
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{t('Recent Documents')}</h5>
                    <Button className="p-0" color="link" size="sm" type="button">
                        {t('View all')}
                    </Button>
                </div>

                <Row>
                    {documents.map((document) => (
                        <Col key={document.id} sm="6" xl="3">
                            <div className="border rounded p-2 h-100 mb-2">
                                <div className="avatar-xs mb-2">
                                    <span className="avatar-title rounded bg-soft-primary text-primary font-size-20">
                                        <i className="ri-file-text-line" />
                                    </span>
                                </div>
                                <small className="d-block text-truncate" title={document.title}>
                                    {t(document.title)}
                                </small>
                                <small className="text-muted">
                                    {`${document.type} · ${document.size}`}
                                </small>
                            </div>
                        </Col>
                    ))}

                    <Col sm="6" xl="3">
                        <div className="border rounded p-2 h-100 mb-2 d-flex flex-column justify-content-center align-items-center text-primary">
                            <i className="ri-upload-cloud-2-line font-size-24" />
                            <small>{t('Add document')}</small>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    RecentDocuments
);
